import { useDispatch } from "react-redux";
import * as actions from "../../../Redux/Actions/index";
import { showErrorToastMessage } from "../../../component/Toasts/Toasts";
import { Strings } from "../../../constant/Strings";
import { useNavigate } from "react-router-dom";

const DeleteInseedProgram = (props: any) => {
  const { hideDeleteModule, deleteModuleId } = props;
  const { deleteSuccess, confirmDelete, cancel, submit } = Strings;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleDelete = () => {
    dispatch(
      actions.deleteInseedModuleAction(deleteModuleId, (res: any) => {
         if (res?.error?.error_description) {
              showErrorToastMessage(res.error.error_description);
            } else if (res.code === 200) {
              showErrorToastMessage(deleteSuccess);
              navigate(`/module-master`);
        }
      })
    );

    hideDeleteModule();
  };
  return (
    <div className="container">
      <div className="row mx-auto">{confirmDelete}</div>
      <div className="modal-btn-wrapper mt-5 mx-auto">
        <div>
          <button
            className="btn cancel-btn buttonsize"
            onClick={hideDeleteModule}
          >
            {cancel}
          </button>
        </div>
        <div>
          <button
            className="btn add-submit-button buttonsize"
            onClick={handleDelete}
          >
            {submit}
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteInseedProgram;
